import styled from 'styled-components'
import { getCssFromTheme } from '../../../utils/css'

export const StyledTag = styled.span`
  ${({ theme }) => getCssFromTheme(theme, 'tag')};
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 7px;
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
  font-weight: ${({ fontWeight }) => fontWeight};
  margin-right: 3px;
  border: 1px solid transparent;
  border-radius: ${({ borderRadius }) => borderRadius || '3px'};
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  white-space: nowrap;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'text')};

  &.selected {
    background-color: ${({ theme }) => theme.color.primary.main};
    color: ${({ theme }) => theme.color.general.white};
  }

  &.isOutlined {
    border: 1px solid ${({ outlineColor, color }) => outlineColor || color};
  }

  &.withBackgroundOpacity {
    background-color: ${({ backgroundColor, hexOpacity }) => `${backgroundColor}${hexOpacity || '40'}`};
    color: ${({ color }) => color};
  }

  .crossIcon {
    padding-left: 5px;
    cursor: pointer;

    div {
      background-color: transparent;
    }
  }
`
